module.exports = __webpack_public_path__ + "static/media/my-pay-app.3d517baa.svg";